import { getEnv, IAnyStateTreeNode } from 'mobx-state-tree';
import { AppEnv } from '..';

export default (self: IAnyStateTreeNode): AppEnv => getEnv<AppEnv>(self);
